import api from '@/app/api/api.ts';
import type {
  LoginResponse,
  PostLoginByHash,
  PostLoginRequest,
  PostVerifyLoginSmsRequest,
} from '@/features/auth/api/types.ts';
import authApi from '@/app/api/authApi.ts';
import type { AxiosResponse } from 'axios';

export async function postLoginByHash(
  data: PostLoginByHash
): Promise<AxiosResponse<LoginResponse>> {
  return api({
    method: 'POST',
    url: '/auth/loginByHash',
    data,
  });
}

export async function postLogin(data: PostLoginRequest) {
  return api({
    method: 'POST',
    url: '/auth/login',
    data,
  });
}

export async function postVerifyLoginSms(data: PostVerifyLoginSmsRequest) {
  return api({
    method: 'POST',
    url: '/auth/verify-sms',
    data,
  });
}

export async function postLogout() {
  return authApi({
    method: 'POST',
    url: '/logout',
    data: '',
  });
}
